import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  grayBG: {
    background: '#F8FAFB 0% 0% no-repeat padding-box',
  },
  noPadding: {
    '&>div': {
      '@media(min-width: 1250px)': {
        padding: '0px !important',
      },
    },
  },
  layout: {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    width: '100%',
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    // maxWidth: 'calc(100% - 205px)',
    height: '100%',
    overflow: 'hidden',
    '&>div': {
      height: 'calc(100vh - 90px)',
      padding: theme.spacing(4, 3),
      color: theme.palette.primary.main,
      overflow: 'auto',
      '@media(min-width: 1750px)': {
        padding: '56px 120px 28px 80px',
      },
    },
  },
  appBar: {
    paddingRight: theme.spacing(3),
    color: theme.palette.primary.main,
    backgroundColor: '#fff',
    border: '1px solid #E3E8F0',
    '&>button': {
      marginRight: theme.spacing(-2),
    },
  },
  navbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
    marginTop: 20,
    marginBottom: 20,
    '& a': {
      marginRight: theme.spacing(4.75),
    },
    '@media(min-width: 1250px)': {
      height: 56,
    },
  },
  logoContainer: {
    cursor: 'pointer',
    maxWidth: 239,
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 160,
      marginTop: 5,
      marginLeft: 10,
    },
  },
  logo: {
    width: '100%',
    height: 'auto',
  },
  profilContainer: {
    display: 'flex',
    alignItems: 'center',
    '& div, hr': {
      marginLeft: 10,
      '@media(min-width: 1250px)': {
        marginLeft: 30,
      },
    },
  },
  burgerMenu: {
    '& div, hr': {
      marginLeft: '0px !important',
      '@media(min-width: 1250px)': {
        marginLeft: '0px !important',
      },
    },
  },
  btnPrimary: {
    minHeight: 38,
    height: 38,
    width: 38,
    minWidth: 38,
    textTransform: 'none',
    background:
      'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
    color: '#fff',
    '@media(min-width: 600px)': {
      minHeight: 48,
      height: 48,
      width: 146,
      minWidth: 146,
    },
  },
  initial: {
    width: 38,
    height: 38,
    background: '#000A8C 0% 0% no-repeat padding-box',
    borderRadius: '100%',
    color: '#fff',
    fontSize: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& span': {
      height: '51%',
    },
  },
  divider: {
    display: 'none',
    '@media(min-width: 1250px)': {
      display: 'block',
      height: '20px',
      marginTop: 'auto',
      marginBottom: 'auto',
    },
  },
  textHeader: {
    display: 'none',
    '@media(min-width: 600px)': {
      display: 'block',
    },
  },
  profile: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 !important',
    cursor: 'pointer',
    '& > span': {
      marginLeft: 10,
      '@media(min-width: 1250px)': {
        marginLeft: 30,
      },
    },
  },
  btnWhite: {
    backgroundColor: '#fff#',
    color: '#0E1247',
    marginTop: 5,
    marginRight: 5,
    borderRadius: 3,
    opacity: 1,
    border: 'solid grey',
    minHeight: 38,
    height: 38,
    width: 38,
    minWidth: 38,
    textTransform: 'none',
    '@media(min-width: 600px)': {
      minHeight: 48,
      height: 48,
      width: 225,
      minWidth: 146,
    },
  },
}));
